"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountService = void 0;
const api_1 = require("./api");
const PATH = '/uaa/api/account';
class AccountService {
    static async sendPasswordResetInstructions(emailAddress) {
        return api_1.API.post({
            url: `${PATH}/reset-password/init`,
            headers: {
                'Content-Type': 'text/plain'
            },
            body: emailAddress
        });
    }
    static async sendAccountActivationInstructions(emailAddress) {
        return api_1.API.post({
            url: `${PATH}/resend-activation`,
            headers: {
                'Content-Type': 'text/plain'
            },
            body: emailAddress
        });
    }
    static async checkPassword(password) {
        return api_1.API.post({
            url: `${PATH}/check-password`,
            headers: {
                'Content-Type': 'text/plain'
            },
            body: password
        });
    }
    static async changePassword(currentPassword, newPassword) {
        return api_1.API.post({
            url: `${PATH}/change-password`,
            body: {
                currentPassword,
                newPassword
            }
        });
    }
    static async changeEmail(email, currentPassword) {
        return api_1.API.put({
            url: `${PATH}/change-email`,
            body: {
                currentPassword,
                email
            }
        });
    }
    static async activateAccount(key) {
        return api_1.API.get({
            url: `uaa/api/activate?key=${key}`
        });
    }
    static async passwordReset(key, newPassword) {
        return api_1.API.post({
            url: `${PATH}/reset-password/finish`,
            body: {
                key,
                newPassword
            }
        });
    }
    static async deactivateAccount() {
        return api_1.API.get({
            url: `${PATH}/deactivate`
        });
    }
    static async reactivateAccount(key, newPassword) {
        return api_1.API.post({
            url: `${PATH}/unsuspend/finish`,
            body: {
                key,
                newPassword
            }
        });
    }
    static async checkUnsuspendKey(key) {
        return api_1.API.get({
            url: `${PATH}/unsuspend?key=${key}`
        });
    }
    static async sendAccountReactivationInstructions(emailAddress) {
        return api_1.API.post({
            url: `${PATH}/unsuspend`,
            headers: {
                'Content-Type': 'text/plain'
            },
            body: emailAddress
        });
    }
    static async isAccountActive(emailAddress) {
        return api_1.API.post({
            url: `uaa/api/player/check-email-active`,
            headers: {
                'Content-Type': 'text/plain'
            },
            body: emailAddress
        });
    }
    static async getAccountDetails() {
        return api_1.API.get({
            url: `${PATH}`
        });
    }
}
exports.AccountService = AccountService;
//# sourceMappingURL=account-service.js.map